import { getEventBus, eventEmitter } from './../namespaces/event-bus'
import type { AccountSwitchPayload } from './models'

export const AccountNamespace = 'account'

export const AccountEvents = {
  accountSwitch: eventEmitter<AccountSwitchPayload>(),
}

const { emit } = getEventBus().register<typeof AccountEvents>(AccountNamespace, AccountEvents)

/**
 * switchAccount updates the user's selected account for use across the entire application
 * @param payload is the payload of the account switch event sent to the eventbus, including the account id and the account name
 */
export const switchAccount = (payload: AccountSwitchPayload): void => {
  emit.accountSwitch(payload)
}
